module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addHint
    }
  }, [_vm._v("新增解题提示")])], 1), _vm._v(" "), _c('hint-table', {
    attrs: {
      "tableData": _vm.hintList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f1c1901"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hintTableFatherDlg/src/main.vue
// module id = 644
// module chunks = 2